import michelPlanquartProfilePhoto from '@presentation/assets/images/michel-planquart-profile-photo.png'

export default function MichelProfileCard() {
  return (
    <div className="flex flex-col items-center rounded-xl bg-linear-to-br from-green to-blue p-6 text-center text-white shadow-lg shadow-black/20">
      <div className="h-24 w-24 overflow-hidden rounded-full ring-2 ring-white/80">
        <img
          src={michelPlanquartProfilePhoto}
          alt="Michel Planquart"
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <h3 className="mt-4 text-xl font-bold text-white">Michel Planquart</h3>
      <p className="mt-2 text-sm text-white">
        Diagnosed in 2020, Michel manages his condition with the dedicated rigour of an athlete. Through his holistic routine and practical tools, he empowers others to actively influence their own progression.
      </p>
    </div>
  )
}
